export function parseLangFromURL(search) {
  try {
    const params = new URLSearchParams(search || (typeof window !== 'undefined' ? window.location.search : ''));
    const raw = (params.get('lang') || '').toLowerCase();
    if (raw === 'es' || raw.startsWith('es-')) return 'es';
    return 'en';
  } catch (e) {
    return 'en';
  }
}

export function isSpanish(lang) {
  return (lang || '').toLowerCase().startsWith('es');
}
